module.exports = __webpack_public_path__ + "img/Total Inward Count.b8e5e58a.svg";